import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FtoReportContext } from '../novelty-check-report-context';
import type { FtoReportState } from '../novelty-check-report-state';
import { Logger } from '@patsnap/tahiti-core';
import { FtoTaskStep } from '@/domains/fto-report/enums';
import { FtoReportTaskStatusModel } from '@/domains/fto-report/models/task-status-model';
import { FtoReportResultRefresh } from '../../report-result-refresh';

@injectable()
export class FtoReportResultState implements FtoReportState {
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(FtoReportResultRefresh)
        private readonly _reportResultRefresh: FtoReportResultRefresh,
        @inject(FtoReportTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: FtoReportTaskStatusModel,
    ) { }

    getStep(): FtoTaskStep {
        return FtoTaskStep.REPORT_CREATED;
    }

    async enter(): Promise<void> {
        // 进入结果状态的逻辑
        this._logger.info('进入结果状态');
        await this._reportResultRefresh.refresh();
    }

    async exit(): Promise<void> {
        // 离开结果状态的逻辑
        this._logger.info('离开结果状态');
    }

    async handleNext(): Promise<void> {
        // 结果状态是最后一步，没有下一步
        this._logger.info('结果状态是最后一步，没有下一步');
    }

    async handlePrevious(context: FtoReportContext): Promise<void> {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = FtoTaskStep.SEARCH_END;
            return state;
        });
        // 返回确认状态
        const confirmState = context.getState(FtoTaskStep.SEARCH_END);
        await context.transitionTo(confirmState);
    }
}
